<div class="cart-item">
  <div class="item-image-column">
    <div class="item-image" [class.isCheckout]="isCheckout()">
      <img
        [ngSrc]="item().image || 'assets/demo/images/product/t-shirt-placeholder.png'"
        width="130"
        height="130"
        [alt]="item().name"
        priority
      />
    </div>
  </div>

  <div class="item-details">
    <h3 class="item-name" [class.checkout]="isCheckout()">
      <a [routerLink]="['/products', item().slug]" class="item-link" [title]="item().name">
        {{ item().name }}
      </a>
    </h3>

    @if (inactive()) {
      <p-tag icon="pi pi-times" severity="danger" value="Not Available!" rounded />
    }

    <div class="item-specs">
      <p class="spec-line">
        <span class="spec-label">Size:</span>
        <span class="spec-value">
          {{
            item().is_gift_card
              ? (item().size | usdPipe: 'USD' : 'symbol' : '1.0-2' : displayCurrency())
              : item().size
          }}
        </span>
      </p>

      @if (item().is_gift_card) {
        @if (item().recipient_name) {
          <p class="spec-line">
            <span class="spec-label">Recipient:</span>
            <span class="spec-value">
              {{ item().recipient_name }}
            </span>
          </p>
        }

        <p class="spec-line">
          <span class="spec-label">Email:</span>
          <span class="spec-value">
            {{ item().email }}
          </span>
        </p>
      }

      @if (!item().is_gift_card) {
        <p class="spec-line">
          <span class="spec-label">Color:</span>
          <span class="spec-value">{{ item().color }}</span>
        </p>
      }
    </div>

    @if (item().input_fields?.length) {
      <div class="custom-inputs">
        <p class="custom-inputs-title">Custom inputs</p>
        @for (inputField of item().input_fields; track inputField.id) {
          <p class="spec-line">
            <span class="spec-label">{{ inputField.label }}:</span>
            <span class="spec-value">{{ getInputDisplayValue(inputField) }}</span>
          </p>
        }
      </div>
    }

    @if (!isGifting() && !readonly()) {
      <div class="quantity-section">
        <p-inputNumber
          [showButtons]="true"
          buttonLayout="horizontal"
          spinnerMode="horizontal"
          [min]="minQuantity"
          inputStyleClass="quantity-input"
          [ngModel]="item().quantity"
          (ngModelChange)="onQuantityChange($event)"
          decrementButtonClass="p-button-text"
          incrementButtonClass="p-button-text"
          incrementButtonIcon="pi pi-plus"
          decrementButtonIcon="pi pi-minus"
        ></p-inputNumber>
        @if (item().minimum_order_quantity && item().minimum_order_quantity_amount) {
          <small class="minimum-order-hint">
            Min. order quantity: {{ item().minimum_order_quantity_amount }}
          </small>
        }
      </div>
    } @else {
      <p class="spec-line">Quantity: {{ item().quantity }}</p>
    }
  </div>

  <div class="item-right-section">
    @if (!readonly()) {
      <button class="remove-button" type="button" (click)="onRemove()" aria-label="Remove item">
        <img
          class="icon-default"
          ngSrc="assets/img/icons/trash.svg"
          alt=""
          width="20"
          height="20"
        />
        <img
          class="icon-hover"
          ngSrc="assets/img/icons/trash-red.svg"
          alt=""
          width="20"
          height="20"
        />
      </button>
    }

    @if (!disablePrices() && !hidePrices()) {
      <div class="price-bottom">
        <div class="item-price">
          {{
            item().quantity * item().price
              | price
              | usdPipe: 'USD' : 'symbol' : '1.2-2' : displayCurrency()
          }}
        </div>
        <!--        <div class="shipping-from">Shipping from Ohio</div>-->
      </div>
    }
  </div>
</div>
